import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge from './Badge';
import { STATUS_TYPES } from '../../constants/statusConfig';

/**
 * <StatusBadge status="in_progress" type="job" /> — the only way to render a
 * status pill. Looks up tone/icon/label from src/constants/statusConfig.js.
 * Unknown statuses fall back to a gray badge with the raw value.
 */
export default function StatusBadge({ status, type = 'job', size = 'md', showIcon = true, className = '' }) {
  const { t } = useTranslation();
  if (!status) return null;
  const config = STATUS_TYPES[type]?.[status];
  if (!config) {
    return (
      <Badge tone="gray" size={size} className={className}>
        {String(status).replace(/_/g, ' ')}
      </Badge>
    );
  }
  return (
    <Badge tone={config.tone} size={size} icon={showIcon ? config.icon : undefined} className={`${config.strike ? 'line-through' : ''} ${className}`}>
      {t(config.i18nKey)}
    </Badge>
  );
}
